<section *ngIf="showTermsContent" class="foruplus-terms">
    <div class="foruplus-terms__content" [innerHTML]="termsContent | safeHtml"></div>
</section>
